<!--
注意：这里组件使用比例值而不是使用原始值目的：
1、按照之前的设计来
2、虽然这样换算增加了复杂度和误差损失，但最重要一点，用户看到的组件位置就是传递到后端的位置
-->
<template>
  <!--合同显示-->
  <div class="cont-wrap">
    <div
      class="contract-view"
      ref="bigBox"
      @drop="dropData($event)"
      @dragover="
        $event => {
          $event.preventDefault();
        }
      "
      v-loading="imgLoading"
    >
      <div class="slider-top">
        <el-slider
          class="slider-bar"
          :value="scaleValue"
          @input="
            val => {
              this.$emit('update:scaleValue', val);
            }
          "
          :min="50"
          :max="200"
          show-input
        >
        </el-slider>
        <span>{{ page }}/{{ items }}</span>
      </div>

      <div class="big-box" :style="`transform:scale(${scaleValue / 100});`">
        <!--合同容器-->
        <div class="cont-box" id="contBox" ref="contBox">
          <img
            class="imgInfo"
            @load="handleImgLoad"
            onerror="this.src='/images/logo/jzq-logo.png'"
            :src="contractInfo.url"
            :key="page"
            alt="合同信息"
            @mousedown.self="pageMousedown($event)"
            @mouseleave="pageLeave($event)"
            @mouseup="
              e => {
                this.handleSetChapte(e);
              }
            "
          />
          <!-- 添加变量按钮 v-show= showAddBtn -->
          <el-button
            v-show="false"
            type="danger"
            size="small"
            :class="{
              'widgets-wrap': true,
              maxTop: true,
              move: true,
              fixed: true
            }"
            :style="addBtnStyle"
            @click="variableAdd"
            >添加变量</el-button
          >
          <!-- 变量组件-->
          <template v-for="(item, index) in chapterList">
            <template
              v-if="imgLoadSus && !imgLoading && item.page === page - 1"
            >
              <template v-if="item.varType >= flagType.flag.SIGNNATURE">
                <!-- 签章组件-->
                <signature
                  relativeNodeId="contBox"
                  :scaleValue="scaleValue"
                  :key="index + 'signature'"
                  :loopkey="index"
                  :item-info="item"
                  :items="items"
                  @quoteCopy="quoteCopy"
                  @BatchSettinsClose="BatchSettinsClose"
                  @changeItemInfo="changeWidgets"
                  @delItemInfo="delWidgets"
                />
              </template>
              <template v-else>
                <!-- 基础组件-->
                <widgets
                  relativeNodeId="contBox"
                  :scaleValue="scaleValue"
                  :key="index + 'widgets'"
                  :loopkey="index"
                  :item-info="item"
                  ref="widgets"
                  @click="selectJCCom"
                  @changeItemInfo="changeWidgets"
                  @delItemInfo="delWidgets"
                  @quoteCopy="quoteCopy"
                  @synchronous="synchronous"
                />
              </template>
            </template>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import widgets from "./widgets";
import signature from "./signature";
import flagType from "./flagType";
import defaultVue from '../../layouts/default.vue';
import {mapGetters} from "vuex";

export default {
  components: {
    widgets,
    signature
  },
  data() {
    return {
      addBtnStyle: {
        left: 0,
        top: 0
      },
      showAddBtn: false, // 添加按钮默认不显示
      flagType,
      imgBox: { width: 0, height: 0 },
      // 当前用户选中拖拽的章的dom对象
      objCurrentCachet: null,
      cachetMove: false,
      currentIndex: null, // 当前拖动的item
      // 控制滚动加载上下页的开关，防止加载多次
      timerKg: true,
      // 加载loading
      imgLoading: true,
      imgLoadSus: false, // 合同是否加载成功
      // 拖动滚动变量
      pageX1: null,
      pageY1: null,
      // ctr+c ctr+v 功能
      selectItem: null, // 当前选中的基础组件
      currentCopyItem: null // 当前复制的组件信息
    };
  },
  props: {
    // 缩放比例结合sync
    scaleValue: { type: Number, default: 100 },
    // 合同图信息
    contractInfo: { type: Object },
    // 签章列表
    chapterList: { type: Array },
    // 当前页
    page: { type: Number, default: 1 },
    // 总页数
    items: { type: Number, default: 0 },
    // 是否固定组件签章-场景：填写变量时
    chapteFixed: { type: Boolean, default: false },
    // 鼠标点击是否触发添加变量显示按钮;默认是打开的
    ADDVariables: { type: Boolean, default: true }
  },
  watch: {
    contractInfo: {
      handler(val) {
        this.imgLoading = true;
        this.clearSlectItem();
        this.$emit("update:contractInfo", val);
      },
      deep: true
    }
    // chapterList: {
    //   handler(val) {
    //     this.$emit('update:chapterList', val)
    //   },
    //   deep: true
    // },
  },
  filters: {
    eclipse(value) {
      if (!value) return "";
      let maxNum = 23;
      value = value + "";
      return value.length > maxNum ? value.substr(0, maxNum) + "..." : value;
    }
  },
  computed: {
    ...mapGetters("advancedVersionState", {
      GET_addTpl_contractInfoJson: "GET_addTpl_contractInfoJson"
    }),
    signerList(){
      return this.GET_addTpl_contractInfoJson.signers ? this.GET_addTpl_contractInfoJson.signers : []
    },
  },
  mounted() {
    this.scrollTurnPage();
    // 2407-22 产品要求 【8155】，默认复制内容不复制变量
    // this.copyJCComponent();
  },
  beforeDestroy() {
    // let domS = this.$refs['scrollBox']
    // domS.removeEventListener('DOMMouseScroll', this.scrollFunc, false);
    this.removeJCComponent();
  },
  methods: {
    /** 印章批量设置 */
    BatchSettinsClose({ApplyForm,CUR}){
      // pageMode 1 全部页面; 2 奇数页面; 3 偶数页面; 4 指定页面;
      const {desi,pageMode} = ApplyForm,
      pages = [...Array(this.items+1).keys()].slice(1);
      let CHAPLIST= [...this.chapterList];
      // 0. 如果存在已经批量设置的签章，清空已存在的批量签章【CHAPLIST】
      if('batch' in CUR){
        // 0.1 如果当前章存在【batch】属性，删除所有【batch】相同值的数据
        CHAPLIST = CHAPLIST.filter(chap=> chap.batch !== CUR.batch);
      }else{
        // 0.2 如果当前没有【batch】，删除当前章
        CHAPLIST = CHAPLIST.filter(chap=> chap.cindex !== CUR.cindex)
      }
      // 1.拆分出需要复制的签章页数
      let batchPage = [],batchChap = [];  
      switch (pageMode) {
        case '2':
          // 获取奇数
          batchPage = pages.filter(num => num % 2 !== 0);
          break;
        case '3':
          // 获取偶数
          batchPage = pages.filter(num => num % 2 === 0);
          break;
        case '4':
          // 获取指定的页数
          const pageArr = desi.replace(/[，,]/g, ',').split(','),result=[];
          for (let item of pageArr) {
            item = item.trim();
            if (item.includes('-')) {
                // 处理区间，如 "4-6"
                const [start, end] = item.split('-').map(Number);
                for (let i = start; i <= end; i++) {
                    result.push(i);
                }
            } else {
                // 处理单个数字
                result.push(Number(item));
            }
          };
          batchPage = [...new Set(result)].sort((a, b) => a - b)
          break;
        default:
          batchPage = pages;
          break;
      }
      // 2.构建出批量签章，并标识 batch 属性
      // // 过滤相同页(例如：在偶数页批量设置，但是在原签章一开始就是拖动在偶数页面)
      // batchPage = batchPage.filter(page=> CUR.page + 1 !== page);
      for (let i = 0; i < batchPage.length; i++) {
        if ((CHAPLIST.length + batchPage.length) >= 30) {
          this.$message({
            message: "温馨提示, 签章最大限制30个!",
            type: "warning"
          });
          break;
        }
        const elem = batchPage[i],start = CHAPLIST.length;
        batchChap.push({
          ...CUR,page:elem - 1,
          batch:CUR.cindex,
          cindex:`${start + i}-${new Date().getTime()}`,
          _ApplyForm:{...ApplyForm}
        })
      }
      // 3.将构建的批量签章push进入 chapterList 数组
      CHAPLIST.push(...batchChap);
      this.$emit("update:chapterList", CHAPLIST);
    },
    /** 【1526】需求定义的复制功能（被复制变量组件不能设置，但原变量中设置改变被复制变量也要改变，类似引用） */
    quoteCopy(quoteItem){
      // 复制时的边界情况处理，复制时的偏移不超过合同有效范围----start
      let currentTypeList = this.chapterList.filter(
        item =>
          (item.page == quoteItem.page && item.cindex == quoteItem.cindex) ||
          (item.page == quoteItem.page && item.copyFrom == quoteItem.cindex)
      ); // 过滤出当前页面的，复制于同一个组件的所有组件，用于计算偏移量

      let newOffsetX = quoteItem.offsetX + 0.03 * currentTypeList.length;
      let newOffsetY = quoteItem.offsetY + 0.03 * currentTypeList.length;
      let {
        top: contBoxTop,
        left: contBoxLeft,
        width: contBoxW,
        height: contBoxH
      } = this.$refs["contBox"].getBoundingClientRect();
      let realWidth = this.scaleToShow(contBoxW);
      if (realWidth <= newOffsetX * realWidth + quoteItem.w * realWidth + 35) {
        // 右侧超出右侧边界值，直接设为复制源头的offset
        newOffsetX = quoteItem.offsetX;
        newOffsetY = quoteItem.offsetY;
      }
      // 复制时的边界情况处理，复制时的偏移不超过合同有效范围----end
      const copy_item={
        ...quoteItem,
        copy:true,
        cindex: this.chapterList.length+1 + "-" + new Date().getTime(),
        offsetX: newOffsetX, // 左下角点位置与合同页面左侧比例
        offsetY: newOffsetY, // 左下角点位置与合同页面顶部比例
        copyFrom: quoteItem.cindex, // 辅助变量，当前组件复制来源标识（ctrl+c+v）
        copyCindex:quoteItem.cindex // 辅组变量2 当前组件复制来源标识（设置弹窗复制点击）
      }
      if(copy_item.varName === quoteItem.varName) copy_item.varName = `${quoteItem.varName}${this.chapterList.length+1}`
      if(copy_item.varName === quoteItem.varName) copy_item.varName = `${quoteItem.varName}${this.chapterList.length+1}`
      this.chapterList.push(copy_item);
      console.log('this.chapterList_复制变量',this.chapterList);
      this.$emit("update:chapterList", this.chapterList);
    },
    /** 同步复制引用变量 */
    synchronous(arr,source){
      // 1.遍历变量数组
      for (let i = 0; i < arr.length; i++) {
        const item = arr[i];
        // 2.传入变量对象的【cindex】与（引入复制对象）【copyCindex】全等且【copy】true
        const isCopyItem = item.copyCindex === source.cindex
        // 3.将满足条件的【copy】的对象值与传入的同步
        if(isCopyItem && item.copy){
          const {inputId,varName,varType,defineValue,value,fontSize,varIsMust,fontMaxNum,h,w, bold, align,signerAbc} = source
          item.inputId=inputId
          item.varName=varName
          item.varType=varType
          item.defineValue=defineValue
          item.value=value
          item.fontSize=fontSize
          item.varIsMust=varIsMust
          item.fontMaxNum=fontMaxNum
          item.w= w
          item.h= h
          item.bold = bold
          item.align = align
          item.signerAbc = signerAbc
        }
      }
      this.$emit("update:chapterList", arr);
    },
    // 添加变量
    variableAdd(ev) {
      ev.preventDefault();
      let {
        top: contBoxTop,
        left: contBoxLeft,
        width: contBoxW,
        height: contBoxH
      } = this.$refs["contBox"].getBoundingClientRect();

      let mx = ev.pageX || ev.screenX,
        // 兼容火狐浏览器无法获取pageY的问题，这里用screenY-浏览器工具栏高度
        my = ev.pageY || ev.screenY - (window.outerHeight - window.innerHeight),
        itemInfo = {
          fontSize: flagType.fontSizeToPx["五号"], // 字号--需要字号转px的方法
          fontMaxNum: 10 // 可输入字数
        };

      // 当前为组件类型如单行文本，日期组件等
      let currentCatpureWH = this.flagType.getWHbyFont(itemInfo), // 当前拖拽出来的组件宽高信息-新增时计算宽高，其他情况使用设置的w，h
        caechetW = this.scaleToVal(parseInt(currentCatpureWH.width)), // 当前组件默认缩放后宽
        caechetH = this.scaleToVal(parseInt(currentCatpureWH.height)), // 当前组件默认缩放后高
        left = mx - contBoxLeft - caechetW / 2, // left>=边界值
        top = my - contBoxTop - caechetH / 2, // 获取组件距离盒子top值，用于计算边界情况>=边界值
        boundaryValue = this.scaleToVal(35); // 合同的最小边界值

      // 处理边界情况
      if (top < boundaryValue) {
        top = boundaryValue;
      } else if (top > contBoxH - caechetH - boundaryValue) {
        top = contBoxH - caechetH - boundaryValue;
      }
      top = top + caechetH; // 生成组件左下角点的y值

      if (left < boundaryValue) {
        left = boundaryValue;
      } else if (left > contBoxW - caechetW - boundaryValue) {
        left = contBoxW - caechetW - boundaryValue;
      }

      // console.log('缩放值:', left, top);
      left = this.scaleToShow(left);
      top = this.scaleToShow(top);
      caechetW = this.scaleToShow(caechetW);
      caechetH = this.scaleToShow(caechetH);
      // console.log('真实值:', left, top);
      this.chapterList.push({
        bold: "", //加粗
        align: "", //对齐方式
        inputId: "",
        value: "", // 填写模板变量时的值
        varName: "", // 名称
        varType: -1, // 类型
        varIsMust: true, // 是否必填
        defineValue:[],
        w: parseFloat((caechetW / this.imgBox.width).toFixed(4)), // 输入框宽度与合同页面宽度比例
        h: parseFloat((caechetH / this.imgBox.height).toFixed(4)), // 输入框高度与合同页面宽度比例
        offsetX: parseFloat((left / this.imgBox.width).toFixed(4)), // 左下角点位置与合同页面左侧比例
        offsetY: parseFloat((top / this.imgBox.height).toFixed(4)), // 左下角点位置与合同页面顶部比例
        page: this.page - 1,
        font: 0, // 宋体
        // 'fontSize': '五号', // 字号--px
        // 'fontMaxNum': 10, // 可输入字数
        ...itemInfo,
        signerAbc: "", // 签署方名称
        // ...辅助变量...
        cindex: this.chapterList.length + "-" + new Date().getTime(),
        qsInfo: "", // 在签章上显示签署方的信息
        // 基础组件辅助变量
        showSetting: true // 基础组件-显示组件设置弹窗
      });
      this.$emit("update:chapterList", this.chapterList);
      this.showAddBtn = false;
    },
    // 获取签章图片宽高
    computeSignImageSize(url, callback) {
      let image = new Image();
      image.src = url;
      image.onload = () => {
        callback(image);
      };
      image.οnerrοr = () => {
        callback();
      };
    },
    /**
     * js根据节点名称，查找某节点的特定父节点
     * @className 父节点中含有当前class的节点
     * */
    getParentNode(node, className) {
      if (!node) return "";
      if (node.nodeName == "BODY") return node;
      let tnode = node.parentNode;
      let cName = tnode.getAttribute("class");
      if (cName === className) return tnode;
      return this.getParentNode(tnode, className);
    },
    async dropData(ev) {
      ev.preventDefault();
      var data = ev.dataTransfer.getData("addZj");
      data = data ? JSON.parse(data) : "";
      if (!data) return false;
      let {
        top: contBoxTop,
        left: contBoxLeft,
        width: contBoxW,
        height: contBoxH
      } = this.$refs["contBox"].getBoundingClientRect();

      let mx = ev.pageX || ev.screenX;
      // 兼容火狐浏览器无法获取pageY的问题，这里用screenY-浏览器工具栏高度
      let my =
        ev.pageY || ev.screenY - (window.outerHeight - window.innerHeight);

      let itemInfo = {
        fontSize: flagType.fontSizeToPx["五号"], // 字号--需要字号转px的方法
        fontMaxNum: 10 // 可输入字数
      };
      if(data.flag >= this.flagType.flag.EMAIL) itemInfo.fontMaxNum = 18
      if(data.flag >= this.flagType.flag.SYSTEMDATE) itemInfo.fontMaxNum = 11
      let caechetW = 0;
      let caechetH = 0;
      if (data.flag >= this.flagType.flag.SIGNNATURE) {
        // 这丽已知签章大小
        caechetW = this.scaleToVal(110); // 签章宽-签章更改这里也需要更改
        caechetH = this.scaleToVal(110); // 签章高-签章更改这里也需要更改
      } else {
        // 当前为组件类型如单行文本，日期组件等
        let currentCatpureWH = this.flagType.getWHbyFont(itemInfo); // 当前拖拽出来的组件宽高信息-新增时计算宽高，其他情况使用设置的w，h
        caechetW = this.scaleToVal(parseInt(currentCatpureWH.width)); // 当前组件默认缩放后宽
        caechetH = this.scaleToVal(parseInt(currentCatpureWH.height)); // 当前组件默认缩放后高
      }

      let left = mx - contBoxLeft - caechetW / 2; // left>=边界值
      let top = my - contBoxTop - caechetH / 2; // 获取组件距离盒子top值，用于计算边界情况>=边界值

      // 处理边界情况
      let boundaryValue = this.scaleToVal(35); // 合同的最小边界值
      if (top < boundaryValue) {
        top = boundaryValue;
      } else if (top > contBoxH - caechetH - boundaryValue) {
        top = contBoxH - caechetH - boundaryValue;
      }
      top = top + caechetH; // 生成组件左下角点的y值

      if (left < boundaryValue) {
        left = boundaryValue;
      } else if (left > contBoxW - caechetW - boundaryValue) {
        left = contBoxW - caechetW - boundaryValue;
      }

      // console.log('缩放值:', left, top);
      left = this.scaleToShow(left);
      top = this.scaleToShow(top);
      caechetW = this.scaleToShow(caechetW);
      caechetH = this.scaleToShow(caechetH);
      // console.log('真实值:', left, top);
      const newIndex = this.chapterList.length+1,twoIndex = this.chapterList.length+2,type_ = data.flag >= this.flagType.flag.SIGNNATURE;
      let newName= type_ ? `印章${newIndex}` : `变量${newIndex}`
      const repeat = this.chapterList.filter(item=> item.inputId === newName)
      if (repeat.length) newName = type_ ? `印章${twoIndex}` : `变量${twoIndex}`
      if(data.varInfo){
        this.chapterList.push({
          ...data.varInfo,
          page: this.page - 1,
          offsetX: parseFloat((left / this.imgBox.width).toFixed(4)), // 左下角点位置与合同页面左侧比例
          offsetY: parseFloat((top / this.imgBox.height).toFixed(4)), // 左下角点位置与合同页面顶部比例
          // ...辅助变量...
          cindex: this.chapterList.length + "-" + new Date().getTime(),
        })
      }else{
        this.chapterList.push({
          bold: "", //加粗
          align: "", //对齐方式
          inputId: newName,
          value: "", // 填写模板变量时的值
          varName: "", // 名称
          varType: data.flag, // 类型
          varIsMust: true, // 是否必填
          defineValue:[],
          w: parseFloat((caechetW / this.imgBox.width).toFixed(4)), // 输入框宽度与合同页面宽度比例
          h: parseFloat((caechetH / this.imgBox.height).toFixed(4)), // 输入框高度与合同页面宽度比例
          offsetX: parseFloat((left / this.imgBox.width).toFixed(4)), // 左下角点位置与合同页面左侧比例
          offsetY: parseFloat((top / this.imgBox.height).toFixed(4)), // 左下角点位置与合同页面顶部比例
          page: this.page - 1,
          font: 0, // 宋体
          // 'fontSize': '五号', // 字号--px
          // 'fontMaxNum': 10, // 可输入字数
          ...itemInfo,
          signerAbc: data.flag === this.flagType.flag.SYSTEMDATE ?
            (this.signerList[0].signerAbc) :
            (data.selectSigner && data.selectSigner.signerAbc || newName),
          // signerAbc: data.selectSigner && data.selectSigner.signerAbc || "",// 签署方名称
          // ...辅助变量...
          cindex: this.chapterList.length + "-" + new Date().getTime(),
          qsInfo: data.selectSigner && data.selectSigner.name || "", // 在签章上显示签署方的信息
          // 基础组件辅助变量
          showSetting: true, // 基础组件-显示组件设置弹窗
          formatStyle: 'yyyy年MM月dd日', //系统日期的日期格式
        });
      }
      this.$emit("update:chapterList", this.chapterList);
    },
    handleImgLoad(el) {
      this.imgLoadSus = true;
      this.imgLoading = false;
      el = el.target;
      let imgEl = el;
      this.imgBox = {
        width: imgEl.naturalWidth || imgEl.width,
        height: imgEl.naturalHeight || imgEl.height
      };
      this.$el
        .querySelector(".cont-box")
        .setAttribute(
          "style",
          `width: ${this.imgBox.width}px; height: ${this.imgBox.height}px;`
        );
    },
    /** 基础组件值更改 */
    changeWidgets(changeItem) {
      console.log("基础组件值更改", changeItem);
      let list =this.chapterList;
      const _copyList = list.filter(elem => elem.copy);
      const arr = list.map(item => {
        const _bool=(item.cindex === changeItem.cindex);
        // ||(!!item.inputId && item.inputId === changeItem.inputId)
        // return changeItem;
        return _bool ? changeItem : item
      });
      // 这里对批量签章做批量处理（不在上面的map方法编码是担心逻辑复杂之后影响以前的需求逻辑）
      const isChap = changeItem.varType >= this.flagType.flag.SIGNNATURE;
      if(isChap){
        arr.forEach(chap=>{
          // 判断拖动的签章是否批量签章
          if(Object.keys(changeItem).includes('batch')){
            // 如果是批量签章（用户操作的是生成的批量章）
            const BATCH = changeItem.batch;
            // 就将 batch 相同(同一批的批量签章)
            // 以及 batch === chap.cindex（批量章的原始章【一开始拖动的章】）的签章都更改位置
            if(BATCH === chap.cindex || BATCH === chap.batch){
              // 当前更改的是批量设置印章，将当前印章以及batch相同记录的印章同步更改
              chap.offsetX= changeItem.offsetX;
              chap.offsetY= changeItem.offsetY;
            }
          }else if(chap.cindex == changeItem.cindex || changeItem.cindex == chap.batch){
            // 如果不是批量签章就将cindex 相同以及 cindex === chap.batch的签章都更改位置
            // （用户拖动的原始章，就将原始章和批量生成的章都改变位置）
            //  chap.cindex == cindex 印章自身 以及批量签章也更改
            chap.offsetX= changeItem.offsetX;
            chap.offsetY= changeItem.offsetY;
          }
        })
      }
      // this.chapterList = arr;
      this.$emit("update:chapterList", arr);
      if(_copyList.length) this.synchronous(arr,changeItem)
    },
    // 删除当前基础组件
    delWidgets(val) {
      const BASECOM = this.chapterList.filter(item => {
        // 这里的逻辑只针对变量
        const isCopyItem = item.copyCindex === val.cindex
        // val.copy 要删除复制变量不筛选出原始变量
        return val.copy ? item.cindex !== val.cindex : (item.cindex !== val.cindex) && !isCopyItem
      });
      // 过滤条件加入是否含有批量签章的判断（这里是签章）
      const _chaps = BASECOM.filter(t=>{
        // 当前签章是否具有批量签章【batch】属性
        if('batch' in val){
          // 如果有删除所有批量签章
          return t.batch !== val.batch
        }else{
          // 否者删除当前签章
          return t.cindex !== val.cindex;
        }
      })
      this.$emit("update:chapterList", _chaps);
    },
    // 页面缩放后的值重新计算为页面真正的值
    scaleToShow(val) {
      return parseFloat(val) / (this.scaleValue / 100);
    },
    // 页面缩放-真实值计算为缩放后的值
    scaleToVal(val) {
      return parseFloat(val) * (this.scaleValue / 100);
    },
    // 滚动翻页
    // 上一页 点击方法
    handlePrePage(bool) {
      if (this.page > 1) {
        this.$emit("pre-page", this.page - 1);
        this.$refs["bigBox"].scrollTop = this.$refs["bigBox"].scrollHeight;
        bool && this.$emit("toCurrentPage", this.page - 1); // 定位当前页左侧目录的位置
      }
    },
    // 下一页合同 点击方法
    handleNextPage(bool) {
      if (this.page < this.items) {
        this.$emit("next-page", this.page + 1);
        this.$refs["bigBox"].scrollTop = 0;
        // 是否定位左侧目录
        bool && this.$emit("toCurrentPage", this.page + 1); // 定位当前页左侧目录的位置
      }
    },
    // 上滚动
    scrollUp(dom) {
      if (dom.scrollTop > 0) return;
      if (!this.timerKg) return;
      this.timerKg = false;
      setTimeout(() => {
        this.handlePrePage(true);
        this.timerKg = true;
      }, 100);
    },
    // 下滚动
    scrollDown(dom) {
      if (dom.clientHeight + dom.scrollTop != dom.scrollHeight) return;
      if (!this.timerKg) return;
      this.timerKg = false;
      setTimeout(() => {
        this.handleNextPage(true);
        this.timerKg = true;
      }, 100);
    },
    // 鼠标滚动翻页
    scrollTurnPage() {
      let domS = this.$refs["bigBox"];
      let scrollFunc = e => {
        e = e || window.event;
        if (e.wheelDelta) {
          //判断浏览器IE，谷歌滑轮事件
          if (e.wheelDelta > 0) {
            //当滑轮向上滚动时
            // alert("滑轮向上滚动");
            this.scrollUp(domS);
          }
          if (e.wheelDelta < 0) {
            //当滑轮向下滚动时
            // alert("滑轮向下滚动");
            this.scrollDown(domS);
          }
        } else if (e.detail) {
          //Firefox滑轮事件
          if (e.detail > 0) {
            // 下
            this.scrollDown(domS);
          }
          if (e.detail < 0) {
            //当滑轮向上滚动时
            this.scrollUp(domS);
          }
        }
      };
      //给页面绑定滑轮滚动事件
      if (domS.addEventListener) {
        //firefox
        domS.addEventListener("DOMMouseScroll", scrollFunc, false);
      }
      //滚动滑轮触发scrollFunc方法  //ie 谷歌
      domS.onmousewheel = scrollFunc;
    },
    // .............滑动页面 start..................
    pageMousedown(el) {
      el.preventDefault();
      let domScroll = document.getElementsByClassName("contract-view")[0];
      let imgDom = document.querySelector(".contract-view .imgInfo");
      this.pageX1 = el.pageX;
      this.pageY1 = el.pageY;
      // console.log(el.target.tagName, el.target.className)
      // console.log(domScroll.parentNode.clientWidth, this.scaleToVal(imgDom.clientWidth))
      console.log(el.target.className, 7788888);
      // if (el.target.className == 'imgInfo' || el.target.className == 'contract-view' || el.target.className == 'big-box') {
      if (el.target.className == "imgInfo") {
        // if(parseInt(domScroll.parentNode.clientWidth) >= this.scaleToVal(imgDom.clientWidth)) return;
        if (!!window.ActiveXObject || "ActiveXObject" in window) {
          el.target.style.cursor = "pointer";
        } else {
          el.target.style.cursor = "grab";
        }
        domScroll.addEventListener("mousemove", this.pageMousemove, false);
        domScroll.addEventListener("mouseup", this.pageMouseStop, false);
      }
    },
    pageMousemove(e) {
      let max = this.scaleToVal(200); // 限制单次最大移动距离
      let domScroll = document.getElementsByClassName("contract-view")[0];
      let x1 = this.pageX1 - e.clientX;
      x1 = Math.abs(x1) > max ? (x1 >= 0 ? max : -max) : x1;
      let y1 = this.pageY1 - e.clientY;
      y1 = Math.abs(y1) > max ? (y1 >= 0 ? max : -max) : y1;
      domScroll.scrollLeft = domScroll.scrollLeft + Math.ceil(x1 / 30);
      domScroll.scrollTop = domScroll.scrollTop + Math.ceil(y1 / 30);
    },
    pageMouseStop(el) {
      let domScroll = document.getElementsByClassName("contract-view")[0];
      let imgDom = document.querySelector(".contract-view .imgInfo");
      imgDom && (imgDom.style.cursor = "default");
      domScroll.removeEventListener("mousemove", this.pageMousemove, false);
      domScroll.removeEventListener("mouseup", this.pageMouseStop, false);
    },
    pageLeave(el) {
      this.pageMouseStop();
    },
    // .............滑动页面 end..................
    // .............ctr+c ctr+v 复制组件 start..................
    copyJCComponent() {
      if (this.chapteFixed) return false; // 填写模板变量时，固定组件签章时不写入ctr + c + ctr + v 事件
      document.addEventListener("keydown", this.copyCtr, false);
      this.$el.addEventListener("mouseleave", this.clearSlectItem, false);
    },
    removeJCComponent() {
      document.removeEventListener("keydown", this.copyCtr, false);
      this.$el.removeEventListener("mouseleave", this.clearSlectItem, false);
    },
    // ctr + c + ctr + v 复制粘贴当前组件,鼠标在合同内才可以复制粘贴
    copyCtr(e) {
      // console.log(e.keyCode);
      if (!this.selectItem) {
        return false;
      }
      if (e.ctrlKey && e.keyCode == 67) {
        // console.log('ctr + c');
        // 清空剪贴板
        let clipboardData = window.clipboardData; //for IE
        if (!clipboardData && e.originalEvent) {
          clipboardData = e.originalEvent.clipboardData;
        }
        clipboardData && clipboardData.setData("Text", "");
        this.currentCopyItem = this.selectItem;
      } else if (e.ctrlKey && e.keyCode == 86) {
        // console.log('ctr + v');
        let copyItem = this.currentCopyItem;
        if (!copyItem) {
          return false;
        }

        // 复制时的边界情况处理，复制时的偏移不超过合同有效范围----start
        let currentTypeList = this.chapterList.filter(
          item =>
            (item.page == copyItem.page && item.cindex == copyItem.cindex) ||
            (item.page == copyItem.page && item.copyFrom == copyItem.cindex)
        ); // 过滤出当前页面的，复制于同一个组件的所有组件，用于计算偏移量

        let newOffsetX = copyItem.offsetX + 0.03 * currentTypeList.length;
        let newOffsetY = copyItem.offsetY + 0.03 * currentTypeList.length;
        let {
          top: contBoxTop,
          left: contBoxLeft,
          width: contBoxW,
          height: contBoxH
        } = this.$refs["contBox"].getBoundingClientRect();
        let realWidth = this.scaleToShow(contBoxW);
        if (realWidth <= newOffsetX * realWidth + copyItem.w * realWidth + 35) {
          // 右侧超出右侧边界值，直接设为复制源头的offset
          newOffsetX = copyItem.offsetX;
          newOffsetY = copyItem.offsetY;
        }
        // 复制时的边界情况处理，复制时的偏移不超过合同有效范围----end

        this.chapterList.push({
          ...copyItem,
          cindex: this.chapterList.length + "-" + new Date().getTime(),
          offsetX: newOffsetX, // 左下角点位置与合同页面左侧比例
          offsetY: newOffsetY, // 左下角点位置与合同页面顶部比例
          copyFrom: copyItem.cindex // 辅助变量，当前组件复制来源
        });
        this.$emit("update:chapterList", this.chapterList);
      }
      return false;
    },
    // 清空复制的selectItem,避免ctr+v一直粘贴组件（当前场景：1、合同页数更改 2、鼠标移出合同）
    clearSlectItem(e) {
      this.selectItem = null;
      this.currentCopyItem = null;
    },
    /**
     * 组件的click的绑定事件
     * */
    selectJCCom(selectedItem) {
      this.chapterList.map(item => {
        if (item.cindex === selectedItem.cindex) {
          this.$set(item, "selected", true);
          // item.selected=true
        } else {
          // item.selected=false
          this.$set(item, "selected", false);
        }
      });
      this.selectItem = selectedItem;
      this.$emit("update:chapterList", this.chapterList);
    },
    // 3.复制偏移后，边界情况的处理
    // .............ctr+c ctr+v 复制组件 end..................
    // 动态计算合同范围内的添加变量按钮样式
    // 计算当前章在页面中的位置
    handleSetChapte(ev) {
      const contBox = this.$refs.contBox;
      if (!contBox) return false;
      if (this.ADDVariables) this.showAddBtn = true;
      let {
        top: contBoxTop,
        left: contBoxLeft,
        width: contBoxW,
        height: contBoxH
      } = contBox.getBoundingClientRect(); // 注意，使用getBoundingClientRect返回时若页面缩放，则返回的是缩放后的值
      let mx = ev.pageX || ev.screenX,
        // 兼容火狐浏览器无法获取pageY的问题，这里用screenY-浏览器工具栏高度
        my = ev.pageY || ev.screenY - (window.outerHeight - window.innerHeight),
        itemInfo = {
          fontSize: flagType.fontSizeToPx["五号"], // 字号--需要字号转px的方法
          fontMaxNum: 10 // 可输入字数
        };
      const currentCatpureWH = this.flagType.getWHbyFont(itemInfo); // 当前拖拽出来的组件宽高信息-新增时计算宽高，其他情况使用设置的w，h
      let caechetW = this.scaleToVal(parseInt(currentCatpureWH.width)), // 当前组件默认缩放后宽
        caechetH = this.scaleToVal(parseInt(currentCatpureWH.height)), // 当前组件默认缩放后高
        left = mx - contBoxLeft - caechetW / 2, // left>=边界值
        top = my - contBoxTop - caechetH / 2; // 获取组件距离盒子top值，用于计算边界情况>=边界值

      // 处理边界情况
      const boundaryValue = this.scaleToVal(35); // 合同的最小边界值
      if (top < boundaryValue) {
        top = boundaryValue;
      } else if (top > contBoxH - caechetH - boundaryValue) {
        top = contBoxH - caechetH - boundaryValue;
      }
      top = top + caechetH; // 生成组件左下角点的y值

      if (left < boundaryValue) {
        left = boundaryValue;
      } else if (left > contBoxW - caechetW - boundaryValue) {
        left = contBoxW - caechetW - boundaryValue;
      }
      const realWidth = this.scaleToShow(contBoxW); // 真实宽
      const realHeight = this.scaleToShow(contBoxH); // 真实高
      let offsetX = parseFloat(
          (this.scaleToShow(left) / this.imgBox.width).toFixed(4)
        ),
        offsetY = parseFloat(
          (this.scaleToShow(top) / this.imgBox.height).toFixed(4)
        ); // 根据组件在合同中左下角位置比例信息换算出left ，top值
      caechetH =
        parseFloat(
          (this.scaleToShow(caechetH) / this.imgBox.height).toFixed(4)
        ) * realHeight;
      caechetW =
        parseFloat(
          (this.scaleToShow(caechetW) / this.imgBox.width).toFixed(4)
        ) * realHeight;
      this.addBtnStyle.left =
        parseFloat((offsetX * realWidth).toFixed(4)) + "px";
      this.addBtnStyle.top =
        parseFloat((offsetY * realHeight - caechetH).toFixed(4)) + "px"; // 保存的时左下角的点位置，显示时计算top值需要减去本身高度
    }
  },
  name: "contract-view"
};
</script>

<style lang="less" scoped>
.font-elips() {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

@sliderHeight: 60px;
.slider-top {
  position: fixed;
  top: 0.7rem;
  /*left: 2.8rem;*/
  left: 3.8rem;
  right: 2.8rem;
  height: 40px;//@sliderHeight;
  line-height: 40px; //@sliderHeight;
  // background: #ffffff;
  // box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  opacity: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.2rem;
  box-sizing: border-box;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  z-index: 2;

  .slider-bar {
    width: 310px;
    display: inline-block;
  }

  /deep/ .el-slider {
    .el-slider__bar {
      background-color: rgba(41, 2, 2, 0.45);
    }

    .el-slider__button {
      border: 2px solid rgba(41, 2, 2, 0.45);
    }

    .el-input__inner {
      border: 1px solid #dcdcdc;
    }

    .el-input-number__decrease,
    .el-input-number__increase {
      background-color: transparent;
      color: rgba(220, 220, 220, 1);

      &:hover {
        color: rgba(236, 28, 28, 1);
      }
    }

    .el-input-number__decrease:hover:not(.is-disabled)
      ~ .el-input
      .el-input__inner:not(.is-disabled),
    .el-input-number__increase:hover:not(.is-disabled)
      ~ .el-input
      .el-input__inner:not(.is-disabled) {
      border-color: rgba(236, 28, 28, 1);
    }

    .el-slider__runway:hover {
      .el-slider__bar {
        transition: all ease 0.2s;
        background-color: rgba(236, 28, 28, 1);
      }

      .el-slider__button {
        transition: all ease 0.2s;
        border: 2px solid rgba(236, 28, 28, 1);
      }
    }
  }
}

.cont-wrap {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-top: @sliderHeight;
  z-index: 1;
  position: relative;
}

.contract-view {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
  position: relative;

  .big-box {
    width: 100%;
    height: 100%;
    transform-origin: 0 0;

    .cont-box {
      text-align: center;
      box-sizing: border-box;
      display: block;
      margin: 0 auto;
      position: relative;
      .widgets-wrap {
        position: absolute;
        z-index: 10;
        &.move {
          z-index: 30;
        }

        &.fixed {
          cursor: default !important;
        }

        // 置于最顶层
        &.maxTop {
          z-index: 666;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/advancedVersion/contractView.vue